document.addEventListener("DOMContentLoaded", function() {

	let footer = document.getElementById('footer');	

    if ( footer ) {
        footer.addEventListener('click', function (event) {

            // If the clicked element isn't a footer menu, return
            if (!event.target.matches('.footer-menu-name')) return;
    
            //toggle the open class
            event.target.classList.toggle('open');
        }, false);
    }	
});
  